import type { ReactElement } from 'react';

import { useTranslation } from 'react-i18next';

import { colorsPalette } from '@/features/cv/templates/colors.constant.ts';

import type { EleganceParams } from './schema';

import { TemplateEditPannelProps } from '../types';

export default function EleganceEditPannel({
  params,
  onChangeParams,
}: TemplateEditPannelProps<EleganceParams>): ReactElement {
  const { t } = useTranslation();

  return (
    <div className="p-3 w-72 space-y-4">
      <div>
        <div className="text-sm font-semibold mb-2">{t('CV.Classic.accentColor')}</div>
        <div className="grid grid-cols-8 gap-2">
          {colorsPalette.map(color => (
            <button
              key={color}
              type="button"
              aria-label={`${t('CV.Classic.accentColor')} ${color}`}
              className="h-6 w-6 rounded-full border cursor-pointer"
              style={{
                backgroundColor: color,
                outline: params.accentColor === color ? `2px solid ${color}` : undefined,
              }}
              onClick={() => onChangeParams({ ...params, accentColor: color })}
            />
          ))}
        </div>
      </div>

      <div>
        <div className="text-sm font-semibold mb-2">{t('CV.profilePicture')}</div>
        <div className="flex items-center gap-2">
          <input
            id="elegance-show-picture"
            type="checkbox"
            checked={params.showProfilePicture}
            onChange={e => onChangeParams({ ...params, showProfilePicture: e.target.checked })}
          />
          <label htmlFor="elegance-show-picture" className="text-sm">
            {t('CV.showPhoto')}
          </label>
        </div>
      </div>

      <div>
        <div className="text-sm font-semibold mb-2">{t('CV.headerStyle')}</div>
        <div className="flex items-center gap-3">
          <label className="flex items-center gap-1 text-sm">
            <input
              type="radio"
              name="elegance-header-style"
              checked={params.headerStyle === 'stripe'}
              onChange={() => onChangeParams({ ...params, headerStyle: 'stripe' })}
            />
            {t('CV.gradient')}
          </label>
          <label className="flex items-center gap-1 text-sm">
            <input
              type="radio"
              name="elegance-header-style"
              checked={params.headerStyle === 'badge'}
              onChange={() => onChangeParams({ ...params, headerStyle: 'badge' })}
            />
            {t('CV.line')}
          </label>
        </div>
      </div>
    </div>
  );
}
